module.exports = __webpack_public_path__ + "img/top6.845d6080.jpg";